import React, { useEffect, useState } from "react";
import axios from "axios";
import config from "./config";
import Navbar from "./Navbar";
import Footer from "./Footer";

const ReservationDetail = ({ match }) => {
  const { orderNo, email } = match.params; // Extract orderNo and email from the URL params
  const [reservation, setReservation] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchReservation = async () => {
      try {
        const response = await axios.get(
          `${config.baseUrl}/api-v2/reservation/track?orderNo=${orderNo}&email=${email}`
        );

        if (response.data.success) {
          setReservation(response.data.data); // Set reservation data if successful
        } else {
          setError(response.data.message);
        }
      } catch (err) {
        setError("Failed to load reservation details");
      } finally {
        setLoading(false);
      }
    };

    fetchReservation();

    // Listen for socket events when reservation is updated
    //   socket.on('reservationUpdated', (newReservation) => {
    //     // Debug the values for better clarity
    //     console.log('Received new reservation: ', newReservation);
    //     console.log('Current orderNo in params: ', orderNo);
    //     console.log(
    //       'New reservation orderNo: ',
    //       newReservation.reservation.orderNo
    //     );

    //     // Check if the new reservation orderNo matches the current one
    //     if (newReservation.reservation.orderNo === Number(orderNo)) {
    //       console.log('Match found! Updating state with new reservation...');

    //       // Update the reservation state with the new reservation data
    //       setReservation((prevReservation) => ({
    //         ...prevReservation,
    //         reservation: {
    //           ...prevReservation.reservation,
    //           ...newReservation.reservation, // Merge the new data
    //         },
    //       }));
    //     } else {
    //       console.log('No match, no state update.');
    //     }
    //   });

    //   return () => {
    //     socket.off('reservationUpdated'); // Clean up listener on unmount
    //   };
  }, [orderNo, email]); // Re-run the effect if orderNo or email changes

  if (loading) {
    return (
      <div className="fixed inset-0 flex items-center justify-center bg-white">
        <div className="w-10 h-10 border-4 border-dashed border-black border-t-transparent rounded-full animate-spin"></div>
      </div>
    );
  }

  if (error) {
    return <div>{error}</div>;
  }

  const statusCheck = (reservationStatus) => {
    let status = "Pending";
    const completeStatus = ["Done"];
    const pendingStatus = [
      "Pending",
      "Hold",
      "Payment Declined",
      "Flight Details Issue",
      "Quote",
    ];
    const consfirmedStatus = [
      "Offered",
      "Farm-out Assigned",
      "Farm-Out On the Way",
      "Farm-out Circling",
      "Farm-out Arrived",
      "Farm-out Customer In Car",
      "Unassigned",
      "Farm-out Unassigned",
      "Dispatch",
      "Assigned",
      "On The Way",
      "Circling",
      "Arrived",
      "Customer In Car",
      "Passenger Dropped Off",
    ];
    const cancelledStatus = [
      "Cancelled",
      "Cancelled by Affiliate",
      "COVID-19 Cancellation",
      "Late Cancel",
      "No Show",
      "Deleted",
      "Reject",
    ];
    if (pendingStatus.includes(reservationStatus)) {
      return (status = "Pending");
    } else if (consfirmedStatus.includes(reservationStatus)) {
      return (status = "Confirmed");
    } else if (cancelledStatus.includes(reservationStatus)) {
      return (status = "Cancelled");
    } else if (completeStatus.includes(reservationStatus)) {
      return (status = "Done");
    }
    return status;
  };

  console.log(reservation, "rrrrr");

  return (
    <div className="flex flex-col min-h-screen bg-[#C4C4C4]">
      <div className="flex-grow">
        <Navbar />
        <div className="mx-auto max-w-2xl py-8 px-4 flex flex-col justify-center items-center space-y-2">
          <h1 className="text-2xl font-bold">BOOKING SUMMARY</h1>
          <div className="bg-white w-full p-4 rounded-md">
            <div className="flex justify-between flex-wrap border-b border-gray-500 py-2">
              <strong className="flex space-x-2">
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect width="20" height="20" rx="5" fill="#D5AF34" />
                  <path
                    d="M15.8403 9.64036L12.0221 6.14036C11.9192 6.04928 11.7814 5.99888 11.6384 6.00002C11.4954 6.00116 11.3586 6.05374 11.2574 6.14645C11.1563 6.23915 11.0989 6.36456 11.0977 6.49566C11.0965 6.62675 11.1514 6.75305 11.2508 6.84736L14.1379 9.49386H4.54546C4.40079 9.49386 4.26206 9.54653 4.15976 9.6403C4.05747 9.73407 4 9.86125 4 9.99386C4 10.1265 4.05747 10.2536 4.15976 10.3474C4.26206 10.4412 4.40079 10.4939 4.54546 10.4939H14.1379L11.2508 13.1404C11.1987 13.1865 11.1571 13.2417 11.1286 13.3027C11.1 13.3637 11.0849 13.4293 11.0843 13.4957C11.0837 13.562 11.0975 13.6279 11.1249 13.6893C11.1523 13.7508 11.1928 13.8066 11.244 13.8536C11.2953 13.9005 11.3562 13.9376 11.4232 13.9628C11.4902 13.9879 11.562 14.0006 11.6345 14C11.7069 13.9994 11.7785 13.9856 11.845 13.9594C11.9116 13.9332 11.9718 13.8951 12.0221 13.8474L15.8403 10.3474C15.9426 10.2536 16 10.1264 16 9.99386C16 9.86127 15.9426 9.73412 15.8403 9.64036Z"
                    fill="black"
                  />
                </svg>
                <span>Booking # {reservation.reservation.orderNo}</span>
              </strong>
              <div className="">
                <strong>Booking Status:</strong>{" "}
                {statusCheck(reservation.reservation.status)}
              </div>
            </div>
            <div className="py-2 border-b border-gray-500">
              <div className="">
                <strong>Passenger Name:</strong>{" "}
                {reservation?.reservation?.PassengerInformation?.firstName ||
                  ""}{" "}
                {reservation?.reservation?.PassengerInformation?.lastName || ""}
              </div>
              <div className="mt-1">
                <strong>Booker Name:</strong>{" "}
                {reservation?.reservation?.customer?.firstName || ""}{" "}
                {reservation?.reservation?.customer?.lastName || ""}
              </div>
            </div>
            <div className="py-2 space-y-2">
              <div className="grid grid-cols-3">
                <strong className="">Pick Up:</strong>
                <div className="col-span-2">
                  {reservation?.reservation?.pickUpLocation || ""}
                </div>
              </div>
              {reservation?.reservation?.stops.length > 0 &&
                reservation?.reservation?.stops?.map((stop, i) => (
                  <div className="grid grid-cols-3" key={i}>
                    <strong className="">Stop-{i + 1}:</strong>
                    <div className="col-span-2">{stop?.address || ""}</div>
                  </div>
                ))}
              <div className="grid grid-cols-3">
                <strong className="">Drop-Off:</strong>
                <div className="col-span-2">
                  {reservation?.reservation?.dropOffLocation || ""}
                </div>
              </div>
              <div className="grid grid-cols-3">
                <strong className="">Date & Time:</strong>
                <div className="col-span-2">
                  {reservation?.reservation?.date}{" "}
                  {reservation?.reservation?.time || ""}
                </div>
              </div>
              {/* <div className="grid grid-cols-3">
                <strong className="">No. of Hours:</strong>
                <div className="col-span-2">5 Hours</div>
              </div> */}
              {reservation?.reservation?.flightDetails?.pickUpFlightDetails
                ?.AirlineCode && (
                <div className="grid grid-cols-3">
                  <strong className="">Airline Info:</strong>
                  <div className="col-span-2">
                    {
                      reservation?.reservation?.flightDetails
                        ?.pickUpFlightDetails?.AirlineName
                    }{" "}
                    {
                      reservation?.reservation?.flightDetails
                        ?.pickUpFlightDetails?.AirlineCode
                    }{" "}
                    {reservation?.reservation?.flightDetails
                      ?.pickUpFlightDetails?.flightNumber || ""}
                  </div>
                </div>
              )}
              <div className="grid grid-cols-3">
                <strong className="">Vehicle:</strong>
                <div className="col-span-2">
                  {reservation?.reservation?.vehicleDetails?.vehicle
                    ?.vehicleName || ""}
                </div>
              </div>
              <div className="grid grid-cols-3">
                <strong className="">Passengers:</strong>
                <div className="col-span-2">
                  {reservation?.reservation?.numberOfPassengers || "0"}
                </div>
              </div>
              <div className="grid grid-cols-3">
                <strong className="">Luggage:</strong>
                <div className="col-span-2">
                  {reservation?.reservation?.luggageCount || "0"}
                </div>
              </div>
              {reservation?.reservation?.addChildSeat?.length > 0 && (
                <div className="grid grid-cols-3">
                  <strong className="">Child Seats:</strong>
                  <div className="col-span-2">
                    {reservation?.reservation?.addChildSeat?.map((seat, i) => (
                      <span key={i}>
                        {" "}
                        {seat.quantity} ({seat.category?.split(" ")[0] ?? ""})
                      </span>
                    ))}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <div className="hidden lg:block">
        <Footer />
      </div>
    </div>
  );
};

export default ReservationDetail;
